// @import dependencies
import React, {Component} from 'react'
// @end

// @import components
import {ArticulosScreenLayout} from 'app_components/screens/landing/articulos'
// @end

// @ADD Component types
interface IArticulosScreenProps {}
interface IArticulosScreenState {}

class ArticulosScreen extends Component<IArticulosScreenProps, IArticulosScreenState> {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IArticulosScreenProps) {
    super(props)
    this.state = {}
  }

  render() {
    return(
      <ArticulosScreenLayout
        {...this.props}
      />
    )
  }
}

export default ArticulosScreen
